import { render } from "./Nav.vue?vue&type=template&id=b212b90a"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"
script.render = render

export default script